import React from 'react';

import Container from 'components/Container';
import styles from './RichText.module.css';

interface RichTextProps {
  text: string;
}

const RichText: React.FCWithChildren<RichTextProps> = ({ text }) => {
  const handleLinkClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLAnchorElement;
    const link = target.getAttribute('href');

    if (link) {
      e.preventDefault();
      window.open(link, '_blank');
    }
  };

  return (
    <Container noNestedPadding>
      <div
        onClick={handleLinkClick}
        className={styles.root}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </Container>
  );
};

export default RichText;
